<script setup>
import { useQuasar } from 'quasar';
import { computed, useSlots } from 'vue';

const $props = defineProps({
    location: Object,
    label: String
});

const $q = useQuasar();
const $slots = useSlots();

const isDefaultSlotDefined = computed(() => !!$slots.default);

const color = computed(() => {
    return $q.dark.isActive
        ? 'brown-10'
        : 'deep-orange-1';
});

const label = computed(() => {
    return $props.label || !isDefaultSlotDefined.value
        ? $props.location?.shortName
        : undefined;
});
</script>

<template>
    <q-chip
        :label
        :color
        text-color="deep-orange-10"
        icon="sym_r_location_pin"
        class="rounded-borders"
    >
        <slot></slot>
    </q-chip>
</template>
